import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import {
  Box,
  // InputAdornment,
  // Paper,
} from '@mui/material'
import { ReactFlowProvider } from '@xyflow/react'
import { useGetProjectModels } from '@/service-library/hooks/project-models'
import ModelInputOutputsDisplay from '@/components/project-settings/ModelInputOutputsDisplay'
import ProjectBreadcrumb from '@/components/project-tables/ProjectBreadcrumb'
import SettingsPage from '@/components/shared/settings/SettingsPage'
import SettingsSection from '@/components/shared/settings/SettingsSection'
import { useSelectedWorkflowContext } from '@/components/workflows/SelectedWorkflowProvider'

// const FIELD_RATIO_DESCRIPTION =
//   'This determines the threshold of new occurrences for a field required for the model to auto-train. For example, if the model was last trained with 100 occurrences for a field, with a threshold of 20%, the model will auto-train after 20 new occurrences are added to the training batch for that field.'
// const CATEGORY_RATIO_DESCRIPTION =
//   'This determines the threshold of new occurrences for a category item required for the model to auto-train. For example, if the model was last trained with 100 occurrences for a category item, with a threshold of 20%, the model will auto-train after 20 new occurrences are added to the training batch for that category item.'

// const FIELD_ACCURACY_DESCRIPTION = `The model will only auto-train if the field accuracy of the field that triggers auto-training is below this threshold. For example, if a field meets the Field Occurrences Ratio, but is already at or above the accuracy level configured here, then it will not trigger auto-training. This prevents unnecessary auto-training.`
// const CATEGORY_ACCURACY_DESCRIPTION = `The model will only auto-train if the field accuracy of the category item that triggers auto-training is below this threshold. For example, if a category item meets the Category Occurrences Ratio, but is already at or above the accuracy level configured here, then it will not trigger auto-training. This prevents unnecessary auto-training.`

export default function ModelConfiguration() {
  const navigate = useNavigate()
  const { selectedWorkflow } = useSelectedWorkflowContext()

  const { projectModels } = useGetProjectModels({
    filters: {
      parent_model_id__isnull: 'true',
      training_workflow_id: selectedWorkflow.id,
      fields__include: 'project_model_type',
    },
  })

  const projectModel = projectModels[0]

  // const [autoTrain, setAutoTrain] = useState(false)
  // const [documentThreshold, setDocumentThreshold] = useState(10)
  // const [occurrencesRatio, setOccurrencesRatio] = useState(20)
  // const [accuracyThreshold, setAccuracyThreshold] = useState(95)

  // const conditionsAreMet =
  //   documentThreshold && occurrencesRatio && accuracyThreshold

  // let borderColor = autoTrain ? 'primary.main' : ''
  // if (autoTrain && !conditionsAreMet) {
  //   borderColor = 'warning.main'
  // }

  useEffect(() => {
    if (selectedWorkflow && !selectedWorkflow?.project_model_id) {
      navigate('..', { relative: 'path' })
    }
  })

  return (
    <>
      <ProjectBreadcrumb label="Model Configuration" url="." />

      <SettingsPage
        title="Model Configuration"
        description="Choose which project fields this model uses as inputs and outputs the next time it trains."
        width="lg"
        fill
      >
        {projectModel && (
          <SettingsSection
            title={projectModel.name}
            description="Inputs are on the left and outputs on the right. Each field's type is set as an output of the model once it's trained."
            variant="plain"
          >
            {/* The diagram fills its container and fits itself to view. */}
            <Box sx={{ flexGrow: 1, minHeight: 400 }}>
              <ReactFlowProvider>
                <ModelInputOutputsDisplay
                  projectModel={projectModel}
                  key={projectModel.id}
                />
              </ReactFlowProvider>
            </Box>
          </SettingsSection>
        )}

        {/* <Paper
          component={Stack}
          variant="outlined"
          sx={{
            borderRadius: 2,
            p: 2,
            borderColor,
            transition: '0.2s',
          }}
          spacing={2}
        >
          <Stack direction="row" justifyContent="space-between">
            <Typography component="h2" variant="h6">
              Auto-Train
            </Typography>
            <Switch
              checked={autoTrain}
              onChange={() => {
                setAutoTrain((prev) => !prev)
              }}
            />
          </Stack>

          // How many documents 
          <TextField
            label="Document Threshold"
            type="number"
            helperText="Number of new documents required before auto-training the model."
            value={documentThreshold}
            disabled={!autoTrain}
            onChange={(event) => {
              setDocumentThreshold(parseInt(event.target.value))
            }}
          />

          <TextField
            label={
              isCategoryModel
                ? 'Category Occurrences Ratio Percent'
                : 'Field Occurrences Ratio Percent'
            }
            type="number"
            value={occurrencesRatio}
            disabled={!autoTrain}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
            helperText={
              isCategoryModel
                ? CATEGORY_RATIO_DESCRIPTION
                : FIELD_RATIO_DESCRIPTION
            }
            onChange={(event) => {
              setOccurrencesRatio(parseInt(event.target.value))
            }}
          />

          <TextField
            label="Field Accuracy Threshold"
            type="number"
            value={accuracyThreshold}
            disabled={!autoTrain}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
            helperText={
              isCategoryModel
                ? CATEGORY_ACCURACY_DESCRIPTION
                : FIELD_ACCURACY_DESCRIPTION
            }
            onChange={(event) => {
              setAccuracyThreshold(parseInt(event.target.value))
            }}
          />

          <Typography
            variant="caption"
            color={!autoTrain ? 'text.secondary' : undefined}
          >
            All conditions must be met before auto-training will occur.
          </Typography>

          {autoTrain && !conditionsAreMet && (
            <Typography variant="caption" sx={{ color: 'warning.main' }}>
              Please fill out all fields to enable auto-training.
            </Typography>
          )}
        </Paper> */}
      </SettingsPage>
    </>
  )
}
